/**
 * Retrieves media devices available on the system.
 * @method getDevices
 * @param  {Object} state Redux state.
 * @return {Object}
 */
export function getDevices (state) {
  return state.webrtc.devices
}

/**
 * Session selectors.
 */
export function getSessions (state) {
  return state.webrtc.sessions
}

export function getSessionById (state, sessionId) {
  return getSessions(state).find(session => session.id === sessionId)
}

/**
 * Track selectors.
 */
export function getTracks (state) {
  return state.webrtc.tracks
}

export function getTrackById (state, trackId) {
  return getTracks(state).find(track => track.trackId === trackId)
}

/**
 * Media selectors.
 * Handles retrieving data from the `state.webrtc.media` substate.
 */

/**
 * Get the list of all media this session.
 * @method getMedia
 * @param  {Object} state Redux state.
 * @return {Array} A list of all media objects.
 */
export function getMedia (state) {
  return state.webrtc.media
}

/**
 * Get a specific media object.
 * @method getMediaById
 * @param  {Object} state Redux state.
 * @param  {string} mediaId The media to retrieve.
 * @return {Object} A media object.
 */
export function getMediaById (state, mediaId) {
  return getMedia(state).find(media => media.id === mediaId)
}

/**
 * Retrieves information about the browser.
 * @method getBrowserDetails
 * @param  {Object} state Redux state.
 * @return {Object}
 */
export function getBrowserDetails (state) {
  return state.webrtc.browser
}
